// extracted by mini-css-extract-plugin
module.exports = {"wrap":"login_wrap__2oflQ","card":"login_card__10ITP","loginMessage":"login_loginMessage__2VdNl","googleButton":"login_googleButton__W8lUp","userIcon":"login_userIcon__25N0I"};